<template>
  <div>
    <a-row :gutter="[12, 24]">
      <a-col :span="14">
        <vxe-toolbar>
          <template #buttons>
            <vxe-button @click="exportDataEvent">
              <a-tooltip>
                <template slot="title">
                  Click to download the similarity result file
                </template>
                <a-icon type="cloud-download" /> TSV
              </a-tooltip>
            </vxe-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          show-overflow
          row-id="id"
          size="small"
          ref="xTable"
          :loading="loading3"
          :loading-config="{
            text: 'Under calculation, for the first time, it usually takes about 30 seconds',
          }"
          :data="tableData3"
        >
          <vxe-column field="cancer" title="Cancer">
            <template #default="{ row }">
              <a @click="plotCancer(row.cancer)">{{ row.cancer }}</a>
            </template>
          </vxe-column>

          <!-- <vxe-column field="dgene" title="Dysregulated gene" width="150px">
            </vxe-column>
            <vxe-column field="pgene" title="Perturbed gene"></vxe-column> -->
          <vxe-column field="median1" title="Median 1"></vxe-column>
          <vxe-column field="median2" title="Median 2"></vxe-column>
          <vxe-column field="R" title="R"></vxe-column>
          <vxe-column field="P" title="P-value"></vxe-column>
          <template #empty>
            <span style="color: grey"> No more data! </span>
          </template>
        </vxe-table>
        <vxe-pager
          background
          size="small"
          :loading="loading3"
          :current-page="tablePage3.currentPage"
          :page-size="tablePage3.pageSize"
          :total="tablePage3.totalResult"
          :page-sizes="[8]"
          :layouts="[
            'PrevPage',
            'JumpNumber',
            'NextPage',
            // 'FullJump',
            // 'Sizes',
            // 'Total',
          ]"
          @page-change="handlePageChange3"
        >
        </vxe-pager>
      </a-col>
      <a-col :span="10"
        >Selected caner: {{ this.cancer }}
        <a-card
          style="width: 100%; margin-top: 10px; height: 450px"
          v-show="corvisible"
        >
          <a-spin
            size="large"
            :spinning="corplot_visible"
            tip="Plotting... please wait ~"
          >
            <object
              :data="this.corplotlinks"
              width="100%"
              height="400"
            ></object>
          </a-spin>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
// import axios from "axios";

export default {
  data() {
    return {
      getdata: null,
      loading3: true,
      tableData3: [],
      tablePage3: {
        currentPage: 1,
        pageSize: 8,
        totalResult: 0,
      },
      //
      visible: false,
      //plot cancer
      cancer: "NA",
      corvisible: false,
      corplot_visible: true,
      corplotlinks: "",
    };
  },
  watch: {
    cancer() {
      (this.corvisible = true),
        (this.corplot_visible = true),
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/03run_corPercancer.php",
            {
              params: {
                ensgId1: "ENSG00000000003",
                ensgId2: "ENSG00000000005",
                cancer: this.cancer,
              },
            }
          )
          .then((response) => {
            if (response.data != "failed") {
              this.corplotlinks =
                "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
                response.data +
                ".pdf";
              console.log(this.corplotlinks);
              this.corplot_visible = false;
            }
          });
    },
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/02run_corAnalysis.php",
        {
          params: {
            ensgId1: "ENSG00000000003",
            ensgId2: "ENSG00000000005",
          },
        }
      )
      .then((response) => {
        if (response.data != "failed") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
                response.data +
                ".json"
            )
            .then((response) => {
              this.getdata = response.data;
              this.findList3(this.getdata);
              this.loading3 = false;
            });
        }
      });
  },
  methods: {
    plotCancer(value) {
      this.cancer = value;
    },
    showOwnDE() {
      this.visible = true;
    },
    exportDataEvent() {
      const list = this.getdata;
      this.$refs.xTable.exportData({
        filename:
          this.$route.query.datasetId +
          "_" +
          this.$route.query.gene +
          "_correlation",
        type: "csv",
        isHeader: true,
        isFooter: true,
        data: list,
      });
    },
    goPerturbgene(value) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
    },
    findList3(data) {
      this.loading3 = true;
      setTimeout(() => {
        const list = data;
        this.loading3 = false;
        this.tablePage3.totalResult = list.length;
        this.tableData3 = list.slice(
          (this.tablePage3.currentPage - 1) * this.tablePage3.pageSize,
          this.tablePage3.currentPage * this.tablePage3.pageSize
        );
      }, 300);
    },
    handlePageChange3({ currentPage, pageSize }) {
      this.tablePage3.currentPage = currentPage;
      this.tablePage3.pageSize = pageSize;
      this.findList3(this.getdata);
    },
  },
};
</script>
<style scpoed>
.perturbgene {
  background-color: #f8766d;
  border-color: #f8766d;
  border-radius: 5px;
  color: white;
}
</style>
